import React from "react";
import CustomModalLayout from "../../../../web/Auth/CustomModalLayout";
import ConfettiIconColor from "../../../../../icons/ConfettiIconColor";
import { Button } from "../../../../../shadcn/components/ui/button";
import Link from "next/link";
import LogoSvg from "../../../../../icons/LogoSvg";
interface AuctionEndedModelProps {
  open: boolean;
  setOpen: any;
}
export default function AuctionEndedModel({
  open,
  setOpen,
}: AuctionEndedModelProps) {
  return (
    <CustomModalLayout
      open={open}
      onClose={() => setOpen(false)}
      childrenClassName="pb-0 px-4"
      className="pt-8 sm:pt-16 pb-8 lg:pb-[60px] w-full mx-4 sm:mx-0 max-w-[650px]"
    >
      <div className="flex flex-col gap-5 items-center w-full">
        {/* <ConfettiIconColor width={36} height={36} /> */}
        <LogoSvg height={30} width={100} />
        <div className="text-xl font-openSans text-brand-textBlack text-center">
          Auction ended successfully!
        </div>
        <div className="text-xs font-sans text-brand-textGrey max-w-[377px] text-center">
          The auction has concluded. The result is subject to approval by the
          authorized officer. Upon approval, the successful bidder will receive
          detailed instructions from the bank regarding the next steps to
          finalize the necessary procedures. Auction Bazaar appreciates your
          interest in our auction properties.
        </div>
        <div className="text-xs font-sans text-brand-textGrey mt-[70px]">
          If you are interested, you can explore properties by visiting{" "}
          <Link href="https://www.auctionbazaar.com/" passHref>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline"
            >
              www.auctionbazaar.com
            </a>
          </Link>
        </div>
        <Button className="w-[230px] mt-8" onClick={() => setOpen(false)}>
          Got it
        </Button>
      </div>
    </CustomModalLayout>
  );
}
